import type { Promotion } from '../../../api/fetchers/promotionsV2/types/promotions';
import { PromotionOptedStatus, PromotionType } from '../../../api/fetchers/promotionsV2/types/promotions';

import type { TopTournamentPoints, PromoPoint } from './types';
import { PromosPopup } from './types';

export const isPromoActiveNow = (promo: Promotion): boolean => {
  const nowEpoch = Date.now() / 1000;
  const { fromEpoch, toEpoch } = promo.activeDuration;
  return fromEpoch <= nowEpoch && nowEpoch <= toEpoch;
};

export const isPromoOpted = (promo: Promotion): boolean => {
  return (
    (!promo.consentRequired && promo.opted === PromotionOptedStatus.Pop) ||
    promo.opted === PromotionOptedStatus.Opted ||
    promo.opted == PromotionOptedStatus.NoPop
    // consider no_pop promotions as opted
  );
};

export const displayPromoForConsent = (promo: Promotion): boolean => {
  return promo.opted === PromotionOptedStatus.Pop;
};

export const updatePromosPopup = (
  showPromosConsentModal: boolean,
  showWinNotification: boolean
): PromosPopup | null => {
  if (showPromosConsentModal) return PromosPopup.PromosConsent;
  if (showWinNotification) return PromosPopup.PromosWinNotification;
  return null;
};

export const getTopTournament = (activePoints: Array<PromoPoint>): TopTournamentPoints | undefined => {
  const filteredPoints = activePoints
    .filter((p) => p.promoType === PromotionType.Tournament && !p.isRoundLimitExceeded)
    .sort((t1, t2) => t1.toEpoch - t2.toEpoch);
  return filteredPoints.reduce((acc, point) => {
    if (!acc) return point;
    if (point.winningStreak > acc.winningStreak) {
      return point;
    }
    return acc;
  }, filteredPoints[0]);
};
